<div fxLayout="row wrap">

  <div class="container" fxFlex="99%" fxFlex.lt-md="100%" fxLayout="column wrap">
    <div class="urlDiv" fxLayout="row wrap">
      <a class="urls" href="/userProfiles/{{userId}}?home=false">
        Home /
      </a>
      <a  class="urls" href="/hitmaker">
         &nbsp;Hitmaker /
      </a>
      <a  class="urls" href="/hitmaker/{{movieId}}">
        &nbsp;{{movieName}} /
</a>
       <a  class="urls"  href="/hitmaker/{{movieId}}">
        &nbsp;Filming
     </a>
      </div>
    <h2 class="heading">FILMING</h2>
    <span class="newPara">Each film will produce and deliver to you on Creatics a web series about the life, work, and dreams of the actors you
    have discovered and cast via the Fans Cast It competitions. The show will follow the actor(s) through the process of
    rehearsals, preparation, filming, and post-production of their respective films. Every time you view and favor an
    episode, that film gets points and you get Creatics Currency. Your currency can be redeemed for prizes and drawings. The
    Movie that gets to X points first gets special rewards.</span>
    <br><br><br>

    <div fxLayout="row" style="justify-content: center; text-align: center;margin-top: -3%">
      <button class="castingBtn" (click)="uploadDetails()" *ngIf="admin">Upload</button>
    </div>
  </div>

  <div fxLayout="row wrap" class="casting-div" fxLayoutGap="15px" style="margin: 31px;">
    <div *ngFor="let details of stageContentDTOs" class="margin-div" [class.show-button-displayed]="details.hidden == true">

      <div class="content" fxLayout="row wrap">

        <mat-card fxLayout="row wrap" style="padding: 0; align-content: space-between;">

          <div *ngIf="playVideo" class="video-overlay">
            <iframe class="iframe-video" [src]="video" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
            <div class="close-icon" (click)="closeVideo()">&#10006;</div>
          </div>

          <div class="image-container" (click)="playVideo1(details.contentUrl)">
            <img class="img" src="{{details.thumbnailURL}}">
            <button href="" class="video-icon">
              <img src="/../../../../../../assets/images/youtube_play_icon.png" alt="Play Video">
            </button>
          </div>

          <mat-card-header style="margin-left: 2%; width: 90%; cursor: pointer;">
            <mat-card-title class="title">{{details.stageContentLabel | titlecase}}</mat-card-title>
          </mat-card-header>

          <mat-card-content *ngIf="admin" style="margin-bottom: 0px; width: 98%; cursor: pointer;">
            <p class="order">Order: {{details.order}}
            </p>
          </mat-card-content>

          <span ng-if="!details.upvoted" style="float:left; padding-bottom:4%; padding-left:4%; font-size: 67%"
            class="ng-scope"><a><button md-button class="md-ink-ripple upvote-off ng-scope"
                (click)="upvoteContent(details)" ng-if="!details.comingSoon" type="button"
                [ngClass]="{'upvote-on': details.upvoted}"></button>
              {{ details.upvoted ? 'JEWELED' : 'JEWEL' }}</a></span>

          <div *ngIf="admin" class="buttons" fxFlex="row wrap" fxLayoutGap="1.7px" fxFlex="100%"
            style="align-self: center; text-align: center;">
            <div id="btnDiv" fxFlex="row">
              <button style="color: #36a344;" (click)="updateShowContent(details)">UPDATE</button>
            </div>
            <button class="btnDiv show" *ngIf="details.hidden==true"
              (click)="showStageContent(details.id)">SHOW</button>
            <button class="btnDiv hide" *ngIf="details.hidden==false" (click)="hideStageContent(details)">HIDE</button>
            <div id="btnDiv" fxFlex="row">
              <button style="color: red;" (click)="deleteStageMovie(details.id)">DELETE</button>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>